module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agree-container"
  }, [_c('div', {
    attrs: {
      "id": "canvas-main"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "replace-html"
    }
  }), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }]
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f92eeed"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/docagree.vue
// module id = 205
// module chunks = 0